module.exports = __webpack_public_path__ + "static/media/ils_gold_purchase_success.5e9108d6.svg";